
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators-leaderboard",
      function () {
        return require("private-next-pages/creators-leaderboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators-leaderboard"])
      });
    }
  